<!--<label [for]="idVal">{{label}}</label>
<select class="form-select" [id]="idVal">
  <option value="">{{defaultOption}}</option>
  <option *ngFor="let optionTemp of inputArray" value="{{optionTemp[this.valueKey]}}">{{optionTemp[this.displayKey]}}</option>
</select>-->

  <label [for]="idVal">{{label}}</label>
  <select class="select-wrapper st-form-select" [id]="idVal">
    <option value="">{{defaultOption}}</option>
    <option *ngFor="let optionTemp of inputArray" value="{{optionTemp[this.valueKey]}}">{{optionTemp[this.displayKey]}}</option>
  </select>
<!--
<script>
  import {EventEmitter} from "@angular/core";

  $(document).ready(function() {
    function onChangeEvent(){
      /*
      const event: Event = new Event("change")
      const elem = document.getElementById(this.idVal);
      // @ts-ignore
      elem.dispatchEvent(event)*/
      const elem = document.getElementById(this.idVal);
      // @ts-ignore
      let dropdownValue = elem.value
      let onchange = new EventEmitter<Event>()
      if (dropdownValue) {
        onchange.emit(dropdownValue)
      }
    }
    onChangeEvent()
  });
</script>
-->
<!--
<mat-form-field>
  <mat-label>{{this.label}}</mat-label>
  <mat-select>
      <mat-option *ngFor="let obj of inputArray" [value]="obj[this.valueKey]">{{obj.displayKey}}</mat-option>
  </mat-select>
</mat-form-field>
-->
<!--
<mat-form-field>
  <mat-label>{{this.label}}</mat-label>
  <mat-select>
    @for (obj of inputArray; track obj) {
    <mat-option [value]="obj[this.valueKey]">{{obj.displayKey}}</mat-option>
    }
  </mat-select>
</mat-form-field>
-->


